import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import { ProductsGroupCarousel } from '@features/products-carousel'

export default function ProductGroupBlock ({
  payload
}: BlockProps) {
  const productGroupId = payload?.id as string

  if (!productGroupId) {
    return null
  }

  return (
    <ProductsGroupCarousel id={productGroupId} />
  )
}